const SummaryEmpty = () => {
  return (
    <div className="flex flex-col items-center justify-center w-full h-16">
      <h1 className="text-lg font-semibold">- V košíku není žádné zboží -</h1>
    </div>
  )
}
export default SummaryEmpty
